import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9PortfoliosEdit } from "./edit";
import { A9PortfoliosNew } from "./new";
import { A9PortfoliosTable } from "./table";
export default function A9Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9PortfoliosEdit />} />
      <Route index element={<A9PortfoliosTable />} />
      <Route path="/new" element={<A9PortfoliosNew />} />
    </Routes>
  );
}
